/**
 * Utilitário para thumbnails em HD - HostVSL Premium 10/10
 * Gera URLs otimizadas para alta qualidade e suporte retina
 */

/**
 * Gera URL de thumbnail em HD para diferentes resoluções
 * @param url - URL original da thumbnail
 * @param width - Largura desejada ('1280' para 1x, '2560' para 2x)
 * @param quality - Qualidade JPEG (85 = alta qualidade)
 */
export function getThumbnailUrl(
  url: string | undefined, 
  width: string = '1280', 
  quality: number = 85
): string {
  if (!url) return '';
  
  // Se for URL do Unsplash, otimizar parâmetros para HD
  if (url.includes('unsplash.com')) {
    const baseUrl = url.split('?')[0];
    return `${baseUrl}?w=${width}&q=${quality}&auto=format&fit=crop`;
  }
  
  // Se for URL genérica com parâmetros de dimensão, atualizar
  if (url.includes('?')) {
    const urlObj = new URL(url);
    
    // Atualizar parâmetros de dimensão se existirem
    if (urlObj.searchParams.has('w') || urlObj.searchParams.has('width')) {
      urlObj.searchParams.set('w', width);
      urlObj.searchParams.delete('width');
    }
    
    // Atualizar qualidade se existir
    if (urlObj.searchParams.has('q') || urlObj.searchParams.has('quality')) {
      urlObj.searchParams.set('q', quality.toString());
      urlObj.searchParams.delete('quality');
    }
    
    return urlObj.toString();
  }
  
  return url;
}

/**
 * Gera atributo srcset para suporte retina (1x/2x)
 * @param url - URL original da thumbnail
 */
export function getThumbnailSrcSet(url: string | undefined): string {
  if (!url) return '';
  
  const url1x = getThumbnailUrl(url, '1280', 85);
  const url2x = getThumbnailUrl(url, '2560', 85);
  
  return `${url1x} 1x, ${url2x} 2x`;
}
